// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2sdyB","topBottomGutter":"Layout_topBottomGutter__2sNwT"};